import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import TransiluminatorCaution from '@common/images/transiluminator-caution.svg';

export function Caution(props) {
  return (
    <Image
      src={TransiluminatorCaution}
      style={props.style}
      alt='transiluminator_caution'
    />
  );
}

Caution.propTypes = {
  /**
   * style to set on component
   */
  style: PropTypes.object,
};
